import { l10nAllLang } from '../common/L10n';
import { escapeTag, getCookie, setCookie, toggle, makeEl, removeClass, addClass } from '../common/Utils';
import { IAutoSuggest } from "../interface/IAutoSuggest";

export default class RecentSearch {

    private recentData: string[] = [];
    private recentWrap: HTMLElement;
    private recentUL!: HTMLElement;
    private recentAllDel!: HTMLElement;
    private recentNone!: HTMLElement;

    private isCookieApply: boolean = false;
    private isUseRecent: boolean = false;

    constructor(private option: IAutoSuggest, private suggestWrap:HTMLElement, private inputEl: HTMLInputElement, private deleteBtn: HTMLElement, private submitFn: ()=>void){
        this.isUseRecent = this.checkUseRecent(this.option.useRecent, this.option.useCookie);
        this.recentWrap = makeEl('div', this.suggestWrap, {'data-name':"suggest_recent"});
        this.recentWrap.style.display = 'none';

        if ( !this.isUseRecent ) return;

        const htmlEl = document.getElementsByTagName("html")[0];
        const lang = htmlEl.getAttribute('lang') || 'en';
        const l10n = l10nAllLang[lang].autoSuggest;

        const scroller = makeEl('div', this.recentWrap, {'data-name':"suggest_recent_scroll"});
        this.recentUL = makeEl('ul', scroller);
        this.recentNone = makeEl('div', scroller, {'data-name':"suggest_recent-none"}, l10n.noRecentSearchHistory);
        this.recentNone.style.display = 'none';
        this.recentAllDel = makeEl('div', this.recentWrap, {'data-name':"suggest_recent-del"});
        makeEl('button', this.recentAllDel, {type: 'button'}, l10n.deleteAllRecent);

        const cookieData = unescape( getCookie(this.option.cookieName) );
        this.recentData = cookieData? JSON.parse( cookieData ): [];

        this.recentAllDel.addEventListener( 'click', () => {
            this.recentData = [];
            setCookie(this.option.cookieName, JSON.stringify(this.recentData));
            this.makeRecentList();
            this.inputEl.value = '';
            this.inputEl.focus();
        });

        this.makeRecentList();
    }

    public setRecentList(_keyword: string){
        if (!this.isUseRecent) return false;
        if( this.recentData.indexOf(_keyword) === -1 ){
            this.recentData.unshift(_keyword);
            this.recentData.splice(5);
            setCookie(this.option.cookieName, JSON.stringify(this.recentData));
            this.makeRecentList();
        }
    }

    public isShow: boolean = false;
    public toggleRecent(_isShow: boolean){
        if (!this.isUseRecent) return false;
        this.isShow = _isShow;
        toggle(this.recentWrap, _isShow);
    }

    private checkUseRecent(_useRecent: boolean | undefined, _useCookie: boolean): boolean{
        return (!!_useRecent && _useCookie);
    }

    private makeRecentList(){
        if (!this.isUseRecent) return false;

        let list = this.recentData.map( (it: string) => {
            return `<li data-keyword="${it}">${escapeTag(it)}<input type="button" data-key="${it}" value="X" title="검색어 삭제"></li>`;
        } ).join('');
        toggle(this.recentNone, !this.recentData.length);
        toggle(this.recentAllDel, this.recentData.length>0);
        this.recentUL.innerHTML = list;
        this.addEvents();
    }

    private addEvents(){
        if (!this.isUseRecent) return false;
        document.querySelectorAll<HTMLElement>( this.option.selector + " [data-name='suggest_recent_scroll'] ul li" ).forEach( it =>{
            it.addEventListener('click', (e: MouseEvent) => {
                const eleT = e.target as HTMLInputElement;
                const eleCT = e.currentTarget as HTMLElement;
                if(eleT.value === "X") return;
                this.inputEl.value = eleCT.dataset.keyword as string;
                this.submitFn();

                if(this.option.useDelbtn){
                    const noneOrBlock = (this.inputEl.value)? 'block': 'none';
                    this.deleteBtn.style.display = noneOrBlock;
                }
            });
        });

        this.recentUL.querySelectorAll<HTMLElement>('li input').forEach((it: HTMLElement)=>{
            it.addEventListener( 'click', (e: MouseEvent) => {
                const ele = <HTMLElement>e.currentTarget;
                const key = <string>ele.dataset.key;
                const idx = this.recentData.indexOf( key );

                this.recentData.splice(idx,1);
                setCookie(this.option.cookieName, JSON.stringify(this.recentData));
                this.makeRecentList();
                this.inputEl.value = '';
                this.inputEl.focus();
            });
        });
    }

    public focusChange( _direction = 1 ){
        let newFocusEl: HTMLElement | null = null;
        let oldFocusEl: HTMLElement | null = this.recentUL.querySelector('.focus');

        if(_direction === 1){
            newFocusEl = ( oldFocusEl )? <HTMLElement>oldFocusEl.nextElementSibling: this.recentUL.querySelector('li:first-child');
        }
        if(_direction === -1){
            newFocusEl = ( oldFocusEl )? <HTMLElement>oldFocusEl.previousElementSibling: this.recentUL.querySelector('li:last-child');
        }

        this.recentUL.querySelectorAll('li').forEach(it=>removeClass(it, 'focus'));

        let dbKeyword = '';

        if( newFocusEl !== null ){
            addClass(newFocusEl, 'focus');
            dbKeyword = newFocusEl.dataset.keyword as string;
            this.inputEl.value = dbKeyword;
        }

        return dbKeyword;
    }

} // end of class
